import { defineSection, Section } from '@decify/cell-shopify/client';
import './search-drawer.scss';
import { Drawer, drawerName, drawerOpeningEvent, textFieldInputEvent, textFieldName, } from '@/components/ui';
export const searchDrawerName = 'SearchDrawer';
export const searchDrawerTagName = 'cell-section-search-drawer';
export class SearchDrawer extends Section {
    elements;
    fetchedTemplates;
    constructor() {
        super(searchDrawerName);
        const resultsElement = this.querySelector('.SectionSearchDrawer__Results');
        if (!resultsElement) {
            throw new Error('Results element not found');
        }
        if (!(resultsElement instanceof HTMLElement)) {
            throw new Error('Element is not an HTMLElement');
        }
        const searchInputElement = this.querySelector('input[type="search"]');
        if (!searchInputElement) {
            throw new Error('Search input element not found');
        }
        if (!(searchInputElement instanceof HTMLInputElement)) {
            throw new Error('Element is not an HTMLInputElement');
        }
        const viewAllButtonElement = this.querySelector('.SectionSearchDrawer__ViewAllButton');
        if (!viewAllButtonElement) {
            throw new Error('View all button element not found');
        }
        if (!(viewAllButtonElement instanceof HTMLElement)) {
            throw new Error('Element is not an HTMLElement');
        }
        const emptyStateElement = this.querySelector('.SectionSearchDrawer__EmptyState');
        if (!emptyStateElement) {
            throw new Error('Empty state element not found');
        }
        if (!(emptyStateElement instanceof HTMLElement)) {
            throw new Error('Element is not an HTMLElement');
        }
        this.elements = {
            searchInput: searchInputElement,
            results: resultsElement,
            viewAllButton: viewAllButtonElement,
            emptyState: emptyStateElement,
        };
        this.fetchedTemplates = [];
        this.handleDrawerOpeningEvent = this.handleDrawerOpeningEvent.bind(this);
        this.handleSearchInputChangeEvent = this.handleSearchInputChangeEvent.bind(this);
        this.fetchSearchResultsMarkup = this.fetchSearchResultsMarkup.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${textFieldName}.${textFieldInputEvent}`, this.handleSearchInputChangeEvent);
        this.subscribe(`${drawerName}.${drawerOpeningEvent}`, this.handleDrawerOpeningEvent);
    }
    handleDrawerOpeningEvent() {
        this.elements.searchInput.focus();
    }
    async handleSearchInputChangeEvent(event) {
        const searchQuery = event.value;
        // Toggle empty state element & search results element.
        if (searchQuery === '') {
            this.showEmptyState();
            this.hideSearchResults();
        }
        else {
            this.hideEmptyState();
            this.showSearchResults();
        }
        const doc = await this.fetchSearchResultsMarkup(searchQuery);
        if (!doc) {
            return;
        }
        this.render(doc);
    }
    async fetchSearchResultsMarkup(searchQuery) {
        // @ts-ignore
        const { routes } = window.Shopify;
        const existingTemplate = this.fetchedTemplates.find((template) => template.name === searchQuery);
        if (existingTemplate) {
            return existingTemplate.doc;
        }
        const response = await fetch(`${routes.root}search?q=${searchQuery}&section_id=search-results`);
        const markup = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(markup, 'text/html');
        this.fetchedTemplates.push({
            name: searchQuery,
            doc,
        });
        return doc;
    }
    showEmptyState() {
        this.elements.emptyState.classList.add('SectionSearchDrawer__EmptyState--Active');
    }
    hideEmptyState() {
        this.elements.emptyState.classList.remove('SectionSearchDrawer__EmptyState--Active');
    }
    showSearchResults() {
        this.elements.results.classList.add('SectionSearchDrawer__Results--Active');
    }
    hideSearchResults() {
        this.elements.results.classList.remove('SectionSearchDrawer__Results--Active');
    }
    render(doc) {
        const searchResults = doc.querySelector('.SectionSearchDrawer__Results');
        const viewAllButton = doc.querySelector('.SectionSearchDrawer__ViewAllButton');
        if (!searchResults || !viewAllButton) {
            return;
        }
        this.elements.results.innerHTML = searchResults.innerHTML;
        this.elements.viewAllButton.innerHTML = viewAllButton.innerHTML;
    }
    onSectionSelect() {
        this.drawerElement.open();
    }
    onSectionDeselect() {
        this.drawerElement.close();
    }
    get drawerElement() {
        const drawerElement = this.querySelector('cell-component-drawer');
        if (!drawerElement) {
            throw new Error('Drawer element not found');
        }
        if (!(drawerElement instanceof Drawer)) {
            throw new Error('Drawer element is not an instance of Drawer');
        }
        return drawerElement;
    }
}
defineSection(searchDrawerTagName, SearchDrawer);
